/**
 * Desgins Queries
 */
import gql from 'graphql-tag'

export const desginsQuery = gql`
  query GetDesigns(
    $limit: Int,
    $offset: Int,
    $userId: String,
    $searchText: String,
    $filterType: String,
    $filterDate: String,
    $startDate: String,
    $endDate: String,
    $showDraftDesigns: Boolean,
    $orderDate: String,
    $orderName: String,
    $orderModel: String,
    $folderId: String
  ) {
    designsResults: myDesigns(
      limit: $limit,
      offset: $offset,
      userId: $userId,
      searchText: $searchText,
      filterType: $filterType,
      filterDate: $filterDate,
      startDate: $startDate,
      endDate: $endDate,
      showDraft: $showDraftDesigns,
      fromLocker: true,
      orderDate: $orderDate,
      orderName: $orderName,
      orderModel: $orderModel
      folderId: $folderId
    ) {
      fullCount
      userName
      designs {
        id
        code
        name
        image
        shared
        folderId: folder_id
        userId: user_id
        onBatchStore
        printApproved: print_approved
        requirePrintApproval: require_print_approval
        requireProCertification: require_pro_certification
        proDesign: pro_design
        shortId: short_id
        createdAt: created_at
        updatedAt: updated_at
        outputSvg: output_svg
        outputPng: output_png
        proCertified: pro_certified
        qualityWarning: quality_warning
        isDraft: is_draft
        imported
        requestedTransferAt: requested_transfer_at
        zipFile: zip_file
        revenue {
          amount
          currency
        }
        product {
          id
          code
          yotpoId: yotpo_id
          name
          active
          type: name
          discontinued
          replacedBy {
            id
            name
            code
            shortDescription: short_description
            images: original_pictures {
              front: front_image
              thumbnail: thumbnail
              genderId: gender_id
            }
          }
          onlyProDesign: only_pro_design
          description: short_description
          shortDescription: short_description
          collections
          isTopProduct
          youthCombined: youth_combined
          sizeTag: size_tag
          hideFitStyles: hide_fit_styles
          weight
          twoPieces: two_pieces
          priceRange {
            quantity
            price
            abbreviation
            shortName: short_name
          }
          genders {
            id
            name: gender
          }
          fitStyles {
            id
            info
            name: description
          }
          sizeRange: size_range {
            id
            name
            isYouth: is_youth
          }
          images: pictures {
            front: front_image
            back: back_image
            left: left_image
            right: right_image
          },
        }
      }
    }
  }
`

export const sendTransferDesignMutation = gql`
  mutation sendTransferDesign($designId: String!, $transferMessage: String) {
    sendTransferDesign(designId: $designId, transferMessage: $transferMessage) {
      message
    }
  }
`

export const designAsPrivateMutation = gql`
  mutation designAsPrivateMutation($designId: String!, $shared: Boolean!) {
    shareDesign(designId: $designId, shared: $shared) {
      message
    }
  }
`

export const createNewFolderMutation = gql`
  mutation createFolder($name: String!, $icon: String, $color: String) {
    createFolder(name: $name, icon: $icon, color: $color) {
      shortId: short_id 
      userId: user_id 
      name
      color 
      items 
      icon 
      createdAt: created_at 
      updatedAt: updated_at 
    }
  }
`

export const deleteFolderMutation = gql`
  mutation deleteFolder($shortId: String!) {
    deleteFolder(shortId: $shortId) {
      message
    }
  }
`

export const editFolderMutation = gql`
  mutation editFolder($shortId: String!, $name: String!, $icon: String, $color: String) {
    editFolder(shortId: $shortId, name: $name, icon: $icon, color: $color) {
      shortId: short_id 
      userId: user_id 
      name
      color 
      items 
      icon 
      createdAt: created_at 
      updatedAt: updated_at 
    }
  }
`

export const deleteDesignMutation = gql`
  mutation deleteDesign($designId: String!) {
    deleteDesign(designId: $designId) {
      message
    }
  }
`

export const assignFolderMutation = gql`
  mutation assignFolder($shortId: String, $designId: String!, $previousFolder: String) {
    assignFolder(shortId: $shortId, designId: $designId, previousFolder: $previousFolder) {
      message
    }
  }
`

export const assignMultipleFoldersMutation = gql`
  mutation assignMultipleFolders($folderId: String!, $designsToMove: [String]!) {
    assignMultipleFolders(folderId: $folderId, designsToMove: $designsToMove) {
      message
    }
  }
`

export const unAssignFolderMutation = gql`
  mutation unAssignFolder($shortId: String!, $designId: String!) {
    unAssignFolder(shortId: $shortId, designId: $designId) {
      message
    }
  }
`

export const deleteDesignMultipleMutation = gql`
  mutation deleteDesignMultiple($designIds: [String]) {
    deleteDesignMultiple(designIds: $designIds) {
      message
    }
  }
`

export const duplicateDesignMutation = gql`
  mutation duplicateDesign($designId: String!) {
    duplicateDesign(designId: $designId) {
      message
      design {
        id
        code
        name
        image
        shared
        proDesign: pro_design
        shortId: short_id
        createdAt: created_at
        outputSvg: output_svg
        outputPng: output_png
        product {
          id
          code
          yotpoId: yotpo_id
          name
          type: name
          description: short_description
          shortDescription: short_description
          collections
          isTopProduct
          youthCombined: youth_combined
          sizeTag: size_tag
          hideFitStyles: hide_fit_styles
          weight
          twoPieces: two_pieces
          priceRange {
            quantity
            price
            abbreviation
            shortName: short_name
          }
          genders {
            id
            name: gender
          }
          fitStyles {
            id
            info
            name: description
          }
          sizeRange: size_range {
            id
            name
            isYouth: is_youth
          }
          images: pictures {
            front: front_image
            back: back_image
            left: left_image
            right: right_image
          }
        }
      }
    }
  }
`

export const changeNameMutation = gql`
  mutation changeDesignName($designId: String!, $name: String!) {
    changeDesignName(designId: $designId, name: $name) {
      message
    }
  }
`

export const getCouponsQuery = gql`
  query getUserCoupons {
    coupon: getUserCoupons {
      code: coupon_code
      expiry
      purpose
    }
  }
`

export const getFeePrices = gql`
  query getFeePrices {
    designReviewPrices: getDesignReviewPrices {
      usd
      aud
      cad
      eur
      chf
      gbp
    }
    testPrintPrices: getTestPrintPrices {
      usd
      aud
      cad
      eur
      chf
      gbp
    }
  }
`

export const getDesignLabInfoQuery = gql`
  query getDesignLabInfo {
    designInfo: getDesignLabInfo(onlyData: true) {
      deliveryDaysPrint: delivery_days_print
      deliveryDaysPhoto: delivery_days_photo
      deliveryDaysReview: delivery_days_review
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyLocker/data.ts